import config from '../config/config.json'
import superagent from 'superagent'

const POST_REMINDEREMAIL_REQUEST = 'POST_REMINDEREMAIL_REQUEST'
const POST_REMINDEREMAIL_SUCCESS = 'POST_REMINDEREMAIL_SUCCESS'
const POST_REMINDEREMAIL_FAILURE = 'POST_REMINDEREMAIL_FAILURE'

export {
  POST_REMINDEREMAIL_REQUEST,
  POST_REMINDEREMAIL_SUCCESS,
  POST_REMINDEREMAIL_FAILURE
}

export function sendReminderEmailRequest() {
  return {
    type: POST_REMINDEREMAIL_REQUEST,
    loading: true
  }
}


export function sendReminderEmailSuccess(body) {
  return {
    type: POST_REMINDEREMAIL_SUCCESS,
    body: body,
    loading: false
  }
}

export function sendReminderEmailFailure(error) {
  return {
    type: POST_REMINDEREMAIL_FAILURE,
    error: error,
    loading: false
  }
}

export function sendReminderEmail(body, cb){
  return function(dispatch) {
    dispatch(sendReminderEmailRequest())
    superagent
    .post(config.BASE + 'api/admin/reminder/')
    .send(body)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        // alert("Could not send reminder email")
        dispatch(sendReminderEmailFailure(err))
      } else {
        alert("Reminder email has been sent")
        dispatch(sendReminderEmailSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

const GET_ADMINDOCUMENT_REQUEST = 'GET_ADMINDOCUMENT_REQUEST'
const GET_ADMINDOCUMENT_SUCCESS = 'GET_ADMINDOCUMENT_SUCCESS'
const GET_ADMINDOCUMENT_FAILURE = 'GET_ADMINDOCUMENT_FAILURE'

export {
  GET_ADMINDOCUMENT_REQUEST,
  GET_ADMINDOCUMENT_SUCCESS,
  GET_ADMINDOCUMENT_FAILURE
}

export function getAdminDocumentRequest() {
  return {
    type: GET_ADMINDOCUMENT_REQUEST,
    loading: true
  }
}


export function getAdminDocumentSuccess(body) {
  return {
    type: GET_ADMINDOCUMENT_SUCCESS,
    body: body,
    loading: false
  }
}

export function getAdminDocumentFailure(error) {
  return {
    type: GET_ADMINDOCUMENT_FAILURE,
    error: error,
    loading: false
  }
}

export function getAdminDocument(DocId, cb) {
  return function(dispatch) {
    dispatch(getAdminDocumentRequest())
    superagent
    .get(config.BASE + 'api/admin/submissions/' + DocId)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        // alert(JSON.stringify("Error Retrieving This Document"))
        dispatch(getAdminDocumentFailure(err))
      } else {
        dispatch(getAdminDocumentSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

const UPDATE_ADMINDOCUMENT_INPUT = 'UPDATE_ADMINDOCUMENT_INPUT'

export { UPDATE_ADMINDOCUMENT_INPUT }

export function updateAdminDocumentInput(key, value) {
  return {
    type: UPDATE_ADMINDOCUMENT_INPUT,
    key: key,
    value: value
  }
}

const PATCH_ADMINDOCUMENT_REQUEST = 'PATCH_ADMINDOCUMENT_REQUEST'
const PATCH_ADMINDOCUMENT_SUCCESS = 'PATCH_ADMINDOCUMENT_SUCCESS'
const PATCH_ADMINDOCUMENT_FAILURE = 'PATCH_ADMINDOCUMENT_FAILURE'

export {
  PATCH_ADMINDOCUMENT_REQUEST,
  PATCH_ADMINDOCUMENT_SUCCESS,
  PATCH_ADMINDOCUMENT_FAILURE
}

export function patchAdminDocumentRequest() {
  return {
    type: PATCH_ADMINDOCUMENT_REQUEST,
    loading: true
  }
}

export function patchAdminDocumentSuccess(body) {
  return {
    type: PATCH_ADMINDOCUMENT_SUCCESS,
    body: body,
    loading: false
  }
}

export function patchAdminDocumentFailure(error) {
  return {
    type: PATCH_ADMINDOCUMENT_FAILURE,
    error: error,
    loading: false
  }
}

export function patchAdminDocument(body, DocId, cb, noAlert) {
  return function(dispatch) {
    dispatch(patchAdminDocumentRequest())
    console.log("<><><><><><><><><><><><><><><><><><><><><><><><>");
    console.log("<><><><><><><><><><><><><><><><><><><><><><><><>");
    console.log("Action Body: ", body);
    console.log("<><><><><><><><><><><><><><><><><><><><><><><><>");
    console.log("<><><><><><><><><><><><><><><><><><><><><><><><>");
    superagent
    .post(config.BASE + 'api/admin/submissions/' + DocId)
    .send(body)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        // alert("Error updating this submission")
        dispatch(patchAdminDocumentFailure(err))
      } else {
        if(noAlert !== true) {
          alert("Submission Updated!");
        }
        dispatch(patchAdminDocumentSuccess(res.body))
        if (cb) {
          cb(res.body)
        }
      }
    })
  }
}

const ADMIN_QUICK_ACCEPT_EMAIL = 'joel.m.marcus@gmail.com';
export { 
  ADMIN_QUICK_ACCEPT_EMAIL
}



// WEBPACK FOOTER //
// ./src/actions/AdminDocument.js